import { SignalService } from './index'
import { emitProjectTaskStatusChanged, emitTextToVideoTaskStatusChanged } from './bus'

let signalService: SignalService | null = null
let activeToken: string | null = null
let eventUnsubscribers: Array<() => void> = []

const bindSignalServiceEvents = (service: SignalService) => {
  if (eventUnsubscribers.length > 0) {
    return
  }

  eventUnsubscribers = [
    service.on('AIProjectTaskStatusChanged', emitProjectTaskStatusChanged),
    service.on('AITextToVideoTaskStatusChanged', emitTextToVideoTaskStatusChanged),
  ]
}

const unbindSignalServiceEvents = () => {
  eventUnsubscribers.forEach(unsubscribe => unsubscribe())
  eventUnsubscribers = []
}

export const connectSignalService = (token: string) => {
  const normalizedToken = token.trim()
  if (!normalizedToken) {
    return
  }

  if (signalService && activeToken === normalizedToken) {
    bindSignalServiceEvents(signalService)
    signalService.connect()
    return
  }

  disconnectSignalService()

  signalService = new SignalService(`${import.meta.env.VITE_API_BASE_URL}/AIWebClipHub`, normalizedToken)
  activeToken = normalizedToken
  bindSignalServiceEvents(signalService)
  signalService.connect()
}

export const disconnectSignalService = () => {
  if (!signalService) {
    unbindSignalServiceEvents()
    activeToken = null
    return
  }

  unbindSignalServiceEvents()
  signalService.destroy()
  signalService = null
  activeToken = null
}
